/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Weight_Settings_Enabled_HintInputs */

const vi_smartlab_weight_settings_enabled_hint = /** @type {(inputs: Smartlab_Weight_Settings_Enabled_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khi tắt, hệ thống ngừng đồng bộ phiếu cân từ SmartLab.`)
};

/**

* @param {Smartlab_Weight_Settings_Enabled_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_weight_settings_enabled_hint = /** @type {((inputs?: Smartlab_Weight_Settings_Enabled_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Weight_Settings_Enabled_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_weight_settings_enabled_hint(inputs)
});